import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import {
  deleteSalesReturn,
  getSalesReturnList,
} from "../../../../services/sales/salesService";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SalesReturnForm from "./salesReturnForm/salesReturnForm";
import SalesReturnDetail from "./SalesReturnDetail";
import Illustration from "../../../../partials/content/Illustration";
const salesReturnDetailColumn = [
  {
    header: "Created At",
    field: "CreatedAt",
    type: "datetime",
  },
  {
    header: "Created By",
    field: "createdByName",
    type: "string",
  },
  {
    header: "Updated At",
    field: "UpdatedAt",
    type: "datetime",
  },
  {
    header: "Updated By",
    field: "updatedByName",
    type: "string",
  },
];

function SalesReturnList({ salesOrderID = 0, salesOrder }) {
  const { reload } = useGlobalData();
  const [salesReturn, setSalesReturn] = useState([]);
  const [openSalesReturnForm, setOpenSalesReturnForm] = useState(false);
  const [openSalesReturnDetail, setOpenSalesReturnDetail] = useState(false);
  const [salesReturnID, setSalesReturnID] = useState(0);

  const handleGetSalesReturnList = async (salesOrderID = 0) => {
    const response = await getSalesReturnList(salesOrderID, 0);
    const { data } = response.data;
    setSalesReturn(data.salesReturn);
  };

  const handleDeleteSalesReturn = () => {
    if (salesReturnID > 0) {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
          cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      })
        .fire({
          title: "Are you sure want to delete this Sales Return ?",
          text: "Please note that you are responsible for this action",
          icon: "question",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
          cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            deleteSalesReturn(salesReturnID).then((response) => {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Deleted",
                html: response.data.message,
                icon: "success",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              handleGetSalesReturnList(salesOrderID);
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Cancelled",
              text: "No change has been made",
              icon: "info",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        });
    }
  };

  useEffect(() => {
    handleGetSalesReturnList(salesOrderID);
  }, [salesOrderID, reload]);

  return (
    <React.Fragment>
      {salesReturn.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesReturn}
            dataDetailColumns={salesReturnDetailColumn}
            onRefreshData={() => {
              handleGetSalesReturnList(salesOrderID);
            }}
            buttons={[
              {
                name: "New Sales Return",
                onClick: (e) => {
                  setOpenSalesReturnForm(true);
                },
                icon: "fas fa-plus-circle",
                color: "primary",
              },
            ]}
            columns={[
              {
                header: "Sales Return ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Process Type",
                field: "processTypeName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Return Date",
                field: "returnDate",
                body: (rowData) => formatDate(rowData.returnDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Sales Amount",
                field: "salesAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.salesAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Sales Return Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setSalesReturnID(rowData.ID);
                          setOpenSalesReturnDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete Sales Return">
                      <button
                        type="button"
                        onClick={(event) => {
                          setSalesReturnID(rowData.ID);
                          handleDeleteSalesReturn();
                        }}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {salesOrder.giStatus > 1 ? (
            <React.Fragment>
              <Illustration
                imageSource="INVIFO Sales.png"
                guidance="You don't have any Sales Returns for this sales order yet"
                guidanceLeftIcon="fas fa-info-circle kt-font-success"
                size="md"
              ></Illustration>
              <div className="text-center py-3">
                <button
                  type="button"
                  className="btn btn-primary btn-md btn-pill btn-bold mx-1"
                  onClick={() => {
                    setOpenSalesReturnForm(true);
                  }}
                >
                  <i className="fas fa-plus-circle"></i>
                  New Sales Return
                </button>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Illustration
                imageSource="INVIFO Sales.png"
                guidance="You don't have any Goods Issued for this sales order yet. Sales Return is not possible"
                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                size="md"
              ></Illustration>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
      <DialogLayout
        open={openSalesReturnForm}
        title="Sales Return Form"
        onCloseDialog={() => {
          setOpenSalesReturnForm(false);
        }}
        maxWIdth="lg"
      >
        <SalesReturnForm
          salesOrderID={salesOrderID}
          onCloseSalesReturn={() => {
            setOpenSalesReturnForm(false);
          }}
          onConfirmSave={() => {
            handleGetSalesReturnList(salesOrderID);
            setOpenSalesReturnForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSalesReturnDetail}
        title="Sales Return Detail"
        onCloseDialog={() => {
          setOpenSalesReturnDetail(false);
        }}
        maxWIdth="lg"
      >
        <SalesReturnDetail
          salesReturnID={salesReturnID}
          onCloseSalesReturn={() => {
            setOpenSalesReturnDetail(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default SalesReturnList;
